import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full flex-grow flex items-stretch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Questions, (Question, currentType) => {
    return (_openBlock(), _createBlock("div", { key: currentType }, [
      (Number(currentType) === _ctx.type)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Question.component), {
              question: _ctx.question,
              "on-select": _ctx.onSelect,
              "show-results": _ctx.showResults
            }, null, 8, ["question", "on-select", "show-results"]))
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}